import React from 'react';
import { defaultListProps } from '~constants/config';
import { List, TextField, EditButton, DeleteWithConfirmButton, ReferenceField } from 'react-admin';
import CustomDatagrid from '~components/CustomDatagrid';

function SubtemaList({ ...props }) {
  return (
    <List {...defaultListProps} {...props}>
      <CustomDatagrid rowClick="edit">
        <TextField source="id" />
        <TextField source="name" />
        <TextField source="nameEn" />
        <TextField source="namePt" />
        <ReferenceField source="theme" reference="themes" linkType={false}>
          <TextField source="nameEs" />
        </ReferenceField>
        <DeleteWithConfirmButton label="" />
        <EditButton label="" />
      </CustomDatagrid>
    </List>
  );
}

export default SubtemaList;
